var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneybox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#0E263D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 30.8333C14.167 25.4907 14.167 22.8195 15.8267 21.1597C17.4864 19.5 20.1577 19.5 25.5003 19.5H31.167C36.5096 19.5 39.1809 19.5 40.8406 21.1597C42.5003 22.8195 42.5003 25.4907 42.5003 30.8333C42.5003 36.1759 42.5003 38.8472 40.8406 40.5069C39.1809 42.1667 36.5096 42.1667 31.167 42.1667H25.5003C20.1577 42.1667 17.4864 42.1667 15.8267 40.5069C14.167 38.8472 14.167 36.1759 14.167 30.8333Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0003 19.4999C34.0003 16.8286 34.0003 15.493 33.1705 14.6631C32.3406 13.8333 31.005 13.8333 28.3337 13.8333C25.6624 13.8333 24.3267 13.8333 23.4969 14.6631C22.667 15.493 22.667 16.8286 22.667 19.4999",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 35.5556C29.8981 35.5556 31.1667 34.4985 31.1667 33.1945C31.1667 31.8905 29.8981 30.8334 28.3333 30.8334C26.7685 30.8334 25.5 29.7763 25.5 28.4723C25.5 27.1683 26.7685 26.1112 28.3333 26.1112M28.3333 35.5556C26.7685 35.5556 25.5 34.4985 25.5 33.1945M28.3333 35.5556V36.5001M28.3333 25.1667V26.1112M28.3333 26.1112C29.8981 26.1112 31.1667 27.1683 31.1667 28.4723",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneybox);
export default __webpack_public_path__ + "static/media/moneybox.eb4ac9b4db748df7cedb7ac0d03c8207.svg";
export { ForwardRef as ReactComponent };